// SearchList.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import mixpanel from 'mixpanel-browser';
import './style';

const SearchList = ({
  _id,
  date,
  title,
  location,
  imageUrl,
  resale,
  type,
  onSelect,
}) => {
  const { userData } = useSelector((state) => state.app);
  const dateObj = new Date(date);

  return (
    <div
      className={`flex gap-6 items-center w-full ${type === 'global' ? 'p-2 md:p-[20px] bd-2' : 'p-2 md:px-5 md:py-5'} cursor-pointer hover`}
      onClick={() => {
        mixpanel.track("Event_Search_Used", {
          "search_query": title,     
          "user_id": userData?._id || "Anonymous",
          "page_url": window.location.href,
        });
        onSelect(_id, resale)}
      }
    >
      <div className="flex w-[51px] h-[60px] flex-col items-center gap-[6px] shrink-0 pb-[10px] rounded-lg bg-white border border-[#ff24591a]">
        <div className="text-primary text-center text-xs not-italic font-medium leading-[104%] uppercase flex justify-center items-center px-3 py-[6px] bg-light rounded-t-lg">
          {dateObj.toLocaleString('en-US', { month: 'long' }).slice(0, 3)}
        </div>
        <div className="text-primary text-center text-base not-italic font-semibold leading-[125%]">
          {dateObj.getDate()}
        </div>
      </div>
      <div className="flex gap-5">
        {window.innerWidth > 600 && (
          <div className="w-[126px] h-[72px] max-h-20 object-cover">
            <img
              src={imageUrl}
              alt="event-image"
              className="w-[126px] h-[72px] max-h-20 object-cover rounded-lg"
            />
          </div>
        )}
        <div className="search-event-card heading-16 flex flex-col gap-1 justify-center items-start md:heading-18 md:gap-2">
          {title}
          <div className="align-middle text-14 md:text-16 text-[#878787]">
            <span>{location}</span>
            <span className="dot" />{' '}
            <span>{dateObj.toLocaleString('en-US', {
              hour: '2-digit',
              minute: '2-digit',
              hour12: true,
            })}</span>
          </div>
          {window.innerWidth < 650 && resale && (
            <img src="/assets/images/ticket-count.svg"
              alt="ticket-count" />
          )}
        </div>
      </div>
      {window.innerWidth > 650 && resale && (
        <img
          src="/assets/images/ticket-count.svg"
          className="ml-auto"
          alt="ticket-count"
        />
      )}
    </div>
  );
};

SearchList.propTypes = {
  date: PropTypes.string.isRequired,
  month: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  ticketCount: PropTypes.string.isRequired,
};

export default SearchList;
